import React from 'react';
import { Button, Flex, Typography } from 'antd';
import { useSelector } from 'react-redux';

import { selectSelected } from '../../../common/store/selectionSlice';
import { COMMON_FILTERS } from '../../utils/common';
import { useDelete } from '../../features/massBroadcasts/hooks/useDelete';

const { Text } = Typography;

export const BroadcastControls = ({ isLoading, filters, updateFilters }) => {
    const { onBulkRemove } = useDelete();

    const { selectedRows } = useSelector(selectSelected);

    const isRowSelected = selectedRows.length > 0;

    const isInitialChange =
        JSON.stringify(filters) === JSON.stringify(COMMON_FILTERS);

    return (
        <>
            <Flex
                align={'center'}
                justify={isRowSelected ? 'space-between' : 'flex-end'}
            >
                {isRowSelected && (
                    <Flex gap={16} align={'center'}>
                        <Button
                            disabled={isLoading}
                            type={'primary'}
                            onClick={() => onBulkRemove(selectedRows)}
                        >
                            Удалить
                        </Button>
                        <Text>Выбрано рассылок: {selectedRows.length}</Text>
                    </Flex>
                )}

                {!isInitialChange && (
                    <div>
                        <Button
                            onClick={() => updateFilters({ ...COMMON_FILTERS })}
                            type={'link'}
                        >
                            Очистить фильтры
                        </Button>
                    </div>
                )}
            </Flex>
        </>
    );
};
